import { apiInstance } from "./networking";

export const submitDocuments = async (query, payload) => {
  const { slectedValue, panNumber, kycRefId, channel, isAadhaarMasked, residentialStatus,isPanVal
   } = query;
  const { data = {} } = await apiInstance.post(
    `primary/upload-document-images?type=${slectedValue}&panCard=${panNumber}&kyc_id=${
      kycRefId || ""
    }&channel=${channel}&isAadhaarMasked=${isAadhaarMasked}&residentialStatus=${residentialStatus}&isPanVal=${isPanVal}`,
    payload
  );
  return data;
};

export const formSixtyUplaodDocument = async (query, payload) => {
  const {
    slectedValue,
    txn_id,
    channel,
    kycRefId: kyc_id,
    isAadhaarMasked,
    residentialStatus
  } = query;
  const { data = {} } = await apiInstance.post(
    `primary/upload-formSixty-images?txn_id=${txn_id}&channel=${channel}&supporting_document_type=${slectedValue}&kyc_id=${kyc_id}&isAadhaarMasked=${isAadhaarMasked}&residentialStatus=${residentialStatus}`,
    payload
  );
  return data;
};

export const submitDocumentsTravel = async (query, payload) => {
  const { slectedValue, panNumber, kycRefId, channel, isAadhaarMasked, txnId,isPanVal,residentialStatus } = query;
  const { data = {} } = await apiInstance.post(
    `primary/upload-document-images-travel?type=${slectedValue}&panCard=${panNumber}&kyc_id=${
      kycRefId || ""
    }&channel=${channel}&isAadhaarMasked=${isAadhaarMasked}&txnId=${txnId}&residentialStatus=${residentialStatus}&isPanVal=${isPanVal}`,
    payload
  );
  return data;
};
